import { Pipe, PipeTransform } from '@angular/core';
import { IArticleVariant } from '../interfaces';

@Pipe({
    name: 'mainStoreSln',
    standalone: false
})
export class MainStoreSlnPipe implements PipeTransform {

  public transform(variant: IArticleVariant): string {
    if (variant?.storageLocationNumber) {
      return variant.storageLocationNumber;
    }

    return variant?.storeLocations?.find(location => location.store?.isMainStore)?.storageLocation ?? '';
  }
}
